import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { TxpHeader } from 'owa-txp';
import { logUsage } from 'owa-analytics';
import Message from 'owa-service/lib/contract/Message';
import { lazyGetSnoozeSubMenu } from 'owa-mail-extended-card';

// This file is duplicated temporarily in owa-txp\lib\components.
// Please keep these files in sync if making any changes

export interface ReadingPaneTxpHeaderProps {
    item: Message;
    initiallySelectedItemId?: string;
}

const ReadingPaneTxpHeader = observer(function ReadingPaneTxpHeader(
    props: ReadingPaneTxpHeaderProps
) {
    const { item, initiallySelectedItemId } = props;
    const getSnoozeSubMenu = lazyGetSnoozeSubMenu.tryImportForRender();

    if (item?.EntityNamesMap) {
        // If we found an item with TxP data, Log RPCountShowTxPName.
        // Compare the itemId to the initiallySelectedItemId to see if the reading pane will scroll.
        // TODO: https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/55617 Check if this is still needed. If so change usage to use useEffect.
        logUsage('RPCountShowTxP', [
            item.ItemId.Id != initiallySelectedItemId /* didScroll */,
            !!initiallySelectedItemId /* isConversationView */,
        ]);
        return <TxpHeader item={item} snoozeSubMenu={getSnoozeSubMenu} />;
    }
    return null;
});
export default ReadingPaneTxpHeader;
